import React, {useState} from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getJsonState} from "modules/selectors";
import {LanguageType} from "modules";
import {SectionTitle} from "./common";
import {media} from "assets/css/media";
import {isArray} from "lodash";

const Wrapper = styled.div`
	color: #ffffff;
`;

export const FAQs: React.FC = () => {
	const {t, i18n} = useTranslation();
	const {faq} = useSelector(getJsonState);

	if (!faq || !isArray(faq)) {
		return null;
	}

	return (
		<Wrapper>
			<SectionTitle>{t("help.fifa.faqs")}</SectionTitle>
			{faq.map(({title, id, text}) => (
				<div key={id}>
					<FaqItem
						title={title[i18n.language as LanguageType]}
						text={text[i18n.language as LanguageType]}
					/>
				</div>
			))}
		</Wrapper>
	);
};

const Content = styled.div<{$isOpen: boolean}>`
	display: ${({$isOpen}) => ($isOpen ? "block" : "none")};
	margin-bottom: 31px;
`;

const Title = styled.div`
	font-weight: 700;
	font-size: 14px;
	line-height: 30px;

	@media (min-width: ${media.mobile}) {
		line-height: 46px;
		font-size: 18px;
	}
`;

interface IFaqItem {
	title: string;
	text: string;
}

export const FaqItem: React.FC<IFaqItem> = ({title, text}) => {
	const [isOpen, setIsOpen] = useState(false);
	const toggleIsOpen = () => setIsOpen(!isOpen);

	return (
		<div>
			<Title onClick={toggleIsOpen}>{title}</Title>
			<Content $isOpen={isOpen} dangerouslySetInnerHTML={{__html: text}} />
		</div>
	);
};
